import { render, staticRenderFns } from "./PaymentsC.vue?vue&type=template&id=7decb450&"
import script from "./PaymentsC.vue?vue&type=script&lang=js&"
export * from "./PaymentsC.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports